export type RoomSlots = {
  id: number;
  captacity: number;
  name: string;
  slots: Slot[];
};

export type Slot = {
  startHour: number;
  endHour: number;
  id: number;
  intersessionDuration: number;
  isMirrorRoom: boolean;
  price: number;
  pricePerPerson: number;
  roomId: number;
  state: SlotState;
};

export enum SlotState {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  BOOKED = 'BOOKED',
}
